import styled, { css } from 'styled-components';

export const HeaderStyled = styled.header`
 
`;

export const LogoStyled = styled.img`
  width:100%;
  max-width: 300px;
  height:60px;
  vertical-align: middle;
`;

export const StyledPlus = styled.span`
  font-weight:900;
  font-size:50px;
  line-height:0;
  text-underline: none !important;
`;